module.exports = __webpack_public_path__ + "img/cardGoods.cd8c2f9f.png";